var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12V14C19 15.6569 17.6569 17 16 17C14.3431 17 13 15.6569 13 14V12C13 10.3431 14.3431 9 16 9C17.6569 9 19 10.3431 19 12ZM19 12V10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10V12M1 12V14C1 15.6569 2.34315 17 4 17C5.65685 17 7 15.6569 7 14V12C7 10.3431 5.65685 9 4 9C2.34315 9 1 10.3431 1 12ZM19 13V15C19 18.3137 16.3137 21 13 21H10",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contactUs.36c0b2648da4ce494936f2790bad9965.svg";
export { ForwardRef as ReactComponent };